import { Box, Button, Card, CardHeader, Container, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import Collapse from '@mui/material/Collapse';
import Grid from 'components/core/Grid';
import styled from 'styled-components';

export const BookingCardWrapper = styled(Grid)`
  ${props => props.theme.breakpoints.down('sm')} {
    padding: 0px !important;

    & .MuiPaper-root {
      box-shadow: none;
      border-radius: 0px;
    }

    &:not(:first-child) {
      margin-top: ${props => props.theme.spacing(3)};
    }
  }
`;

export const BookingCardItem = styled(Card)`
  min-height: ${props => props.theme.spacing(46)};
  &:hover {
    box-shadow: ${props => props.theme.shadows[3]};
    background-color: ${props => props.theme.palette.grey[50]};
  }
`;

export const BookingHeaderWrapper = styled.div`
  position: relative;
  border-bottom: 1px solid ${props => props.theme.palette.grey[300]};
  border-top: 1px solid ${props => props.theme.palette.grey[300]};
`;

export const BookingImage = styled.div`
  height: ${props => props.theme.spacing(23)};
  background-size: cover;
  background-position: center;

  ${props => props.theme.breakpoints.down('sm')} {
    height: ${props => props.theme.spacing(20)};
  }

  &:hover {
    cursor: pointer;
  }
`;

export const BookingTitleGrid = styled(Grid)`
  border-bottom: 1px dashed ${props => props.theme.palette.grey[300]};
`;

export const BookingDetails = styled(Grid)`
  padding: ${props => props.theme.spacing(2)};

  & .background--white {
    background-color: #fff;
  }
`;

export const StyledDialogContent = styled(DialogContent)`
  padding: ${props => props.theme.spacing(3)};
`;

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${props => props.theme.palette.grey[300]};
  margin-top: ${props => props.theme.spacing(1)};
  padding: ${props => props.theme.spacing(2)};
  & button {
    min-width: 9rem;
  }

  &.centered {
    justify-content: center;
  }

  &.noMargin {
    margin: 0px;
  }
`;

export const AccessWrapper = styled(Box)`
  margin-left: ${props => props.theme.spacing(2)};
  margin-right: ${props => props.theme.spacing(2)};
  margin-top: ${props => props.theme.spacing(4)};
  padding: ${props => props.theme.spacing(2)};
  background-color: ${props => props.theme.palette.grey[50]};
  border: 1px solid ${props => props.theme.palette.grey[300]};
  border-radius: 5px;

  ${props => props.theme.breakpoints.down('sm')} {
    border-radius: 0px;
    margin-left: 0px;
    margin-right: 0px;
    border-left: 0px solid transparent;
    border-right: 0px solid transparent;
  }
`;

export const StyledCardHeader = styled(CardHeader)`
  background-color: ${props => props.theme.palette.primary.main};
  color: #fff;
  height: ${props => props.theme.spacing(6)};
`;

export const StyledDialogActions2 = styled(DialogActions)`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${props => props.theme.palette.grey[300]};
  margin-top: ${props => props.theme.spacing(1)};

  &.centered {
    justify-content: center;
  }
`;

export const StyledButton = styled(Button)`
  min-width: 9rem;
  margin-left: ${props => props.theme.spacing(1)};
`;

export const StyledDialogTitle = styled(DialogTitle)`
  border-bottom: 1px solid ${props => props.theme.palette.grey[300]};
`;

export const BookingDetailsImageWrapper = styled(Grid)`
  display: flex;
  flex-direction: column;

  & button {
    margin-top: ${props => props.theme.spacing(1)};
  }
`;

export const BookingDetailsImage = styled.div`
  height: 100%;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 5px;
    border: 1px solid ${props => props.theme.palette.grey[300]};
  }
`;

export const StyledTopContainer = styled(Container)`
  border: 1px solid ${props => props.theme.palette.grey[300]};
  border-top: 0px solid transparent;
  margin-top: ${props => props.theme.layout.toolBarHeight.md}px;
  background-color: ${props => props.theme.palette.grey[50]};
  padding: ${props => props.theme.spacing(3)};

  ${props => props.theme.breakpoints.down('sm')} {
    margin-top: 0;
    padding: ${props => props.theme.spacing(0.5)};
  }
`;

export const StyledContainer = styled(Container)`
  border-left: 1px solid ${props => props.theme.palette.grey[300]};
  border-right: 1px solid ${props => props.theme.palette.grey[300]};
  background-color: #fff;
  ${props => props.theme.breakpoints.down('md')} {
    border-left: 0px solid transparent;
    border-right: 0px solid transparent;
    overflow-x: hidden;
  }

  ${props => props.theme.breakpoints.down('sm')} {
    padding: ${props => props.theme.spacing(1.5)};
  }
`;

export const ContentGrid = styled(Grid)`
  margin-top: 0px !important;
`;

export const BackButtonNav = styled(Grid)`
  & .MuiButton-root {
    background-color: #fff;
  }
`;

export const StyledPaymentContent = styled(DialogContent)`
  & .MuiStepper-root {
    padding-left: 0px;
    padding-right: 0px;
  }

  & .MuiStepLabel-root {
    padding: ${props => props.theme.spacing(1)};
    background-color: ${props => props.theme.palette.grey[50]};
    border: 1px solid ${props => props.theme.palette.grey[300]};
    border-radius: 3px;
  }

  & .MuiStepLabel-label {
    text-transform: uppercase;
  }

  & .MuiStepIcon-completed {
    color: ${props => props.theme.palette.secondary.main};
  }

  ${props => props.theme.breakpoints.down('sm')} {
    padding: ${props => props.theme.spacing(1)};

    & .MuiStepContent-root {
      border-left: transparent;
      margin-left: 0px;
      padding-left: ${props => props.theme.spacing(1)};
      padding-right: ${props => props.theme.spacing(1)};
    }
  }
`;

export const StyledTaxesGrid = styled(Grid)`
  display: flex;
  align-items: center;

  & button {
    margin-left: ${props => props.theme.spacing(2)};
    min-width: 1rem;
    padding: 0px;
  }
`;

export const StyledCollapse = styled(Collapse)`
  & .MuiCollapse-wrapper {
    background-color: ${props => props.theme.palette.grey[50]};
    border: 1px solid ${props => props.theme.palette.grey[300]};
    padding: ${props => props.theme.spacing(1)};
    border-radius: 5px;
    margin-top: ${props => props.theme.spacing(1)};
  }

  & .MuiTypography-root {
    font-size: 0.75rem !important;
    font-weight: normal;
  }
`;

export const BookingTotalRow = styled(Grid)`
  border: 1px solid ${props => props.theme.palette.primary.main};
  background-color: ${props => props.theme.palette.grey[50]};
  padding: ${props => props.theme.spacing(1)} !important;
  margin: ${props => props.theme.spacing(2)} 0;
  border-radius: 3px;

  & p {
    font-weight: 500;
  }
`;

export const BookingTotalRowDue = styled(Grid)`
  background-color: ${props => props.theme.palette.primary.main};
  color: #fff;
  padding: ${props => props.theme.spacing(1)} !important;
`;

export const ManagePropertyImageWrapper = styled(Box)`
  position: relative;
  transition: all 0.2s;

  &:before {
    font-family: 'Material Icons';
    content: 'search';
    position: absolute;
    pointer-events: none;
    /* color: #fff;
    font-size: 100px;
    opacity: 0.8;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
    font-size: 30px;
    color: ${props => props.theme.palette.secondary.main};

    background-color: rgba(255, 255, 255, 0.85);
    top: 0;
    left: 0;
    border-bottom-right-radius: 10px;
    padding: 0 ${props => props.theme.spacing(1)};
  }

  &:hover {
    cursor: pointer;
    filter: brightness(0.95);
  }

  &:active,
  &:focus {
    cursor: pointer;
    filter: brightness(1.1);
  }
`;

export const ManagePropertyImage = styled.div`
  height: ${props => props.theme.spacing(27.25)};
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  transition: all 0.2s;

  ${props => props.theme.breakpoints.down('sm')} {
    height: ${props => props.theme.spacing(20)};
  }

  &:hover {
    box-shadow: ${props => props.theme.shadows[3]};
  }
`;

export const ReservationOptionsCard = styled(Card)`
  min-height: ${props => props.theme.spacing(29.5)};

  ${props => props.theme.breakpoints.down('md')} {
    min-height: 0px;
  }
`;

export const ContactTracingList = styled(Grid)`
  ${props => props.theme.breakpoints.up('sm')} {
    min-height: ${props => props.theme.spacing(22.5)};
    max-height: ${props => props.theme.spacing(22.5)};
    overflow: auto;
  }
`;
